var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "6 6 19 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 11h12v9.586l-2.646-3.647a.5.5 0 0 0-.707 0L15 19.586l-3.646-4.647a.5.5 0 0 0-.707 0L8 18.586zm-2-1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm18-4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-1V9.5A1.5 1.5 0 0 0 21.5 8H9V7a1 1 0 0 1 1-1zm-5.5 8a1.5 1.5 0 1 0-2.999-.001A1.5 1.5 0 0 0 18.5 14"
})));
export default SvgNoImage;